import {
  Notification,
  NotificationsSummary,
  NotificationUpdatePayload,
  NotificationUpdateResponse,
} from "@contexts/Notifications/types";
import { useApiOriginacao } from "./base/useApiOriginacao";

export const useApiGetNotificationsSummary = () => {
  return useApiOriginacao<NotificationsSummary>({
    method: "GET",
    url: "/notificacoes/resumo/",
  });
};

export const useApiGetNotifications = () => {
  return useApiOriginacao<Notification[]>({
    method: "GET",
    url: "/notificacoes/",
  });
};

export const useApiUpdateNotification = () => {
  return useApiOriginacao<
    NotificationUpdateResponse,
    NotificationUpdatePayload
  >({
    method: "PATCH",
    url: "/notificacoes/",
  });
};
